import { Stack, TextField } from '@mui/material';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import FormatPhoneInput from '../../../../components/FormatNumber/FormatPhoneInput';

export default function CreateManagerForm(): JSX.Element {
  const {
    control,
    formState: { errors }
  } = useFormContext();

  return (
    <Stack spacing={3}>
      <Controller
        name="firstName"
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            label="FIRST NAME *"
            variant="outlined"
            error={!!errors.firstName}
            helperText={errors.firstName ? errors.firstName?.message : ''}
          />
        )}
      />
      <Controller
        name="lastName"
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            label="LAST NAME *"
            variant="outlined"
            error={!!errors.lastName}
            helperText={errors.lastName ? errors.lastName?.message : ''}
          />
        )}
      />
      <Controller
        name="email"
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            type="email"
            label="EMAIL ADDRESS *"
            variant="outlined"
            error={!!errors.email}
            helperText={errors.email ? errors.email?.message : ''}
          />
        )}
      />
      <Controller
        name="phoneNumber"
        control={control}
        render={({ field }) => (
          <TextField
            label="PHONE NUMBER"
            {...field}
            InputProps={{
              // eslint-disable-next-line
              inputComponent: FormatPhoneInput as any
            }}
          />
        )}
      />
      <Controller
        name="notes"
        control={control}
        render={({ field }) => (
          <TextField {...field} label="NOTES" variant="outlined" />
        )}
      />
    </Stack>
  );
}
